/**
 * Simple tooltip functionality for elements with data-tooltip attributes.
 */
(function() {
	'use strict';

	// Create tooltip element
	const tooltip = document.createElement('div');
	tooltip.className = 'sc-tooltip';
	tooltip.setAttribute('aria-hidden', 'true');
	document.body.appendChild(tooltip);

	// Track current tooltip target
	let currentTarget = null;

	/**
	 * Show tooltip for an element.
	 *
	 * @param {HTMLElement} element - The element to show tooltip for.
	 */
	function showTooltip(element) {
		const tooltipText = element.getAttribute('data-tooltip');
		if (!tooltipText) return;

		currentTarget = element;
		tooltip.textContent = tooltipText;
		tooltip.style.visibility = 'visible';
		tooltip.style.opacity = '1';

		// Position tooltip
		positionTooltip(element);
	}

	/**
	 * Hide tooltip.
	 */
	function hideTooltip() {
		tooltip.style.visibility = 'hidden';
		tooltip.style.opacity = '0';
		currentTarget = null;
	}

	/**
	 * Position tooltip relative to element.
	 *
	 * @param {HTMLElement} element - The element to position relative to.
	 */
	function positionTooltip(element) {
		const rect = element.getBoundingClientRect();
		const tooltipRect = tooltip.getBoundingClientRect();
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

		// Default position (above element)
		let top = rect.top + scrollTop - tooltipRect.height - 8;
		let left = rect.left + scrollLeft + (rect.width / 2) - (tooltipRect.width / 2);

		// Check if tooltip would go off-screen
		const viewportWidth = window.innerWidth;
		const viewportHeight = window.innerHeight;

		// Adjust horizontal position if tooltip would go off-screen
		if (left < 8) {
			left = 8;
		} else if (left + tooltipRect.width > viewportWidth - 8) {
			left = viewportWidth - tooltipRect.width - 8;
		}

		// If tooltip would go above viewport, position below element
		if (top < scrollTop + 8) {
			top = rect.bottom + scrollTop + 8;
		}

		tooltip.style.top = top + 'px';
		tooltip.style.left = left + 'px';
	}

	/**
	 * Handle mouse enter event.
	 *
	 * @param {Event} event - The mouse enter event.
	 */
	function handleMouseEnter(event) {
		showTooltip(event.target);
	}

	/**
	 * Handle mouse leave event.
	 *
	 * @param {Event} event - The mouse leave event.
	 */
	function handleMouseLeave(event) {
		hideTooltip();
	}

	/**
	 * Handle scroll and resize events to reposition tooltip.
	 */
	function handleReposition() {
		if (currentTarget) {
			positionTooltip(currentTarget);
		}
	}

	// Add event listeners
	document.addEventListener('mouseenter', function(event) {
		if (event.target instanceof Element && event.target.hasAttribute('data-tooltip')) {
			handleMouseEnter(event);
		}
	}, true);

	document.addEventListener('mouseleave', function(event) {
		if (event.target instanceof Element && event.target.hasAttribute('data-tooltip')) {
			handleMouseLeave(event);
		}
	}, true);

	// Reposition tooltip on scroll and resize
	window.addEventListener('scroll', handleReposition, { passive: true });
	window.addEventListener('resize', handleReposition, { passive: true });

	// Clean up on page unload
	window.addEventListener('beforeunload', function() {
		if (tooltip.parentNode) {
			tooltip.parentNode.removeChild(tooltip);
		}
	});

})();
